export const messages = {
  en: {
    regulationCategories: {
      search: {
        title: 'Search Condition',
        categoryName: 'categoryName',
        parentId: 'parentId',
        sortOrder: 'sortOrder',
        placeholder: 'Please enter regulationCategories name'
      },
      list: {
        title: 'regulationCategories List'
      },
      dialog: {
        addTitle: 'Add RegulationCategories',
        editTitle: 'Edit RegulationCategories',
        delTitle: 'Delete RegulationCategories',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        categoryId: 'categoryId',
        categoryName: 'categoryName',
        parentId: 'parentId',
        sortOrder: 'sortOrder',
      },
      table: {
        categoryId: 'categoryId',
        categoryName: 'categoryName',
        parentId: 'parentId',
        sortOrder: 'sortOrder',
      },
      validate: {
        categoryId: 'Please enter categoryId',
        categoryName: 'Please enter categoryName',
        sortOrder: 'Please enter sortOrder',
      },
      add: {
        success: 'Add RegulationCategories success'
      },
      edit: {
        success: 'Edit RegulationCategories success'
      },
      delete: {
        success: 'Delete RegulationCategories success',
        confirm: 'Are you sure to delete this regulationCategories?'
      },
      fetchError: 'Failed to fetch regulationCategories list'
    }
  },
  zh: {
    regulationCategories: {
      search: {
        title: '查询条件',
        categoryName: '分类名称',
        parentId: '父分类ID',
        sortOrder: '排序序号',
        placeholder: '请输入制度分类名称'
      },
      list: {
        title: '制度分类'
      },
      dialog: {
        addTitle: '添加制度分类',
        editTitle: '编辑制度分类',
        delTitle: '删除制度分类',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        categoryId: '分类ID',
        categoryName: '分类名称',
        parentId: '父分类ID',
        sortOrder: '排序序号',
      },
      table: {
        categoryId: '分类ID',
        categoryName: '分类名称',
        parentId: '父分类ID',
        sortOrder: '排序序号',
      },
      validate: {
        categoryId: '请输入分类ID',
        categoryName: '请输入分类名称',
        sortOrder: '请输入排序序号',
      },
      add: {
        success: '添加制度分类成功'
      },
      edit: {
        success: '编辑制度分类成功'
      },
      delete: {
        success: '删除制度分类成功',
        confirm: '确认删除该制度分类吗？'
      },
      fetchError: '获取制度分类列表失败'
    }
  }
}